export const SAVE_SIGNUP_DATA = 'save_signup_data';
export const MAKE_SIGNUP_REQUEST = 'make_signup_request';